import { IConfiguredHttp } from './http';

interface ICardResponse {
	method_type: 'card';
	card_details: {
		brand: string;
		wallet_type?: string;
		last4: string;
		expiry_month: number;
		expiry_year: number;
	};
}

interface IRevolutResponse {
	method_type: 'revolut_pay';
}

export type ISearchPaymentDetailsResponse = ICardResponse | IRevolutResponse;

export interface IHostPaymentsApi {
	chargeHostCancellation: (
		customerId: string,
		bookingId: string,
		price: number,
		currency: string,
		description: string,
		tax?: {
			percentage: number;
			name: string;
		}
	) => Promise<{ success: boolean }>;
	searchPaymentDetails: (
		tnCustomerId: string
	) => Promise<ISearchPaymentDetailsResponse>;
}

const hostPaymentsApiFactory = (http: IConfiguredHttp): IHostPaymentsApi => ({
	chargeHostCancellation(
		customerId: string,
		bookingId: string,
		price: number,
		currency: string,
		description: string,
		tax?: {
			percentage: number;
			name: string;
		}
	) {
		return http.post(
			`/host/charge-payment-details/customer/${customerId}`,
			{
				booking_id: bookingId,
				price,
				currency,
				description,
				tax,
			}
		);
	},

	searchPaymentDetails(tnCustomerId: string) {
		return http.post(
			`/host/search-payment-details/customer/${tnCustomerId}`
		);
	},
});

export default hostPaymentsApiFactory;
